import React, { Component } from "react";
import {
  FooterBox,
  SocialWrap,
  LinkBox,
  LinkWrap,
  LinkItems,
  LinkItem,
} from "./atoms";
import { FaGithub, FaLinkedinIn, FaInstagram } from "react-icons/fa";

class Footer extends Component {
  render() {
    return (
      <>
        <FooterBox>
          <SocialWrap>
            <LinkItems>
              <LinkItem href="https://github.com/evancn7">
                <FaGithub />
              </LinkItem>
              <LinkItem href="https://www.linkedin.com/in/evan-campion/">
                <FaLinkedinIn />
              </LinkItem>
              <LinkItem href="https://instagram.com/evan_campion/">
                <FaInstagram />
              </LinkItem>
            </LinkItems>
          </SocialWrap>
        </FooterBox>
      </>
    );
  }
}

export default Footer;
